<template>
  <div class="filterDate">
    <b-modal
      ref="openModal"
      class="filterDateModal"
      scrollable
      size="sm"
      :title="filterName"
      @ok="modalOk"
    >
      <label>{{ $t("geral.whatFilterMode") }}</label>
      <b-form-select
        v-model="getFilterOption"
        id="optionFilterDate"
        :options="optionsFilterDate"
      >
      </b-form-select>
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button variant="green" @click="ok()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <div class="right">
      <b-button variant="link" @click="modalOpen">
        <i class="tim-icons icon-settings-gear-63 btn-filter-settings"> </i>
      </b-button>
    </div>
    <div v-if="optionFilterDate == 0">
      <b-form-input
        class="dateIndividual"
        type="date"
        v-model="getFilterFill"
      />
    </div>
    <div v-if="optionFilterDate == 1">
      <b-form-input class="fieldDate" type="date" v-model="getFilterBegin" />
      <b-form-input type="date" v-model="getFilterEnd" />
    </div>
    <div v-if="optionFilterDate == 2" class="todayDate">
      <b-form-input v-model="today" :readonly="true" />
    </div>
    <!-- <pre class="language-json"><code>dateFill: {{ dateFill  }}</code></pre> -->
    <!-- <pre class="language-json"><code>dateBegin: {{ dateBegin  }}</code></pre> -->
    <!-- <pre class="language-json"><code>dateEnd: {{ dateEnd  }}</code></pre> -->
    <!-- <pre class="language-json"><code>filterDate: {{ filterDate  }}</code></pre> -->
  </div>
</template>

<script>
export default {
  name: "BaseFilterDateWorkflow",
  props: {
    dateFill: String,
    dateBegin: String,
    dateEnd: String,
    filterName: String,
    optionFilterDate: Number,
    filterDate: Object,
  },
  data: function () {
    return {
      optionsFilterDate: [
        { value: 0, text: this.$t("geral.filterDateSame") },
        // { value: 1, text: this.$t("geral.filterDateRange") },
        { value: 2, text: this.$t("geral.filterDateToday") },
      ],
      todayDate: "",
      today: "Hoje",
      filter: {},
    };
  },
  created() {
    this.filter = this.filterDate;
    if (this.optionFilterDate == 2) this.getTodayDate();
  },
  computed: {
    getFilterFill: {
      get: function () {
        return this.dateFill;
      },
      set: function (value) {
        this.$emit("update:dateFill", value);
        // this.$emit("update:dateBegin", value);
        // this.$emit("update:dateEnd", `${value}T23:59:59`);
      },
    },
    getFilterBegin: {
      get: function () {
        return this.dateBegin;
      },
      set: function (value) {
        this.$emit("update:dateBegin", value);
      },
    },
    getFilterEnd: {
      get: function () {
        return this.dateEnd.replace("T23:59:59", "");
      },
      set: function (value) {
        if (!value) {
          value = value.replace("T23:59:59", "");
          this.$emit("update:dateEnd", `${value}`);
        } else {
          value = value.replace("T23:59:59", "");
          this.$emit("update:dateEnd", `${value}T23:59:59`);
        }
      },
    },
    getFilterOption: {
      get: function () {
        return this.optionFilterDate;
      },
      set: function (value) {
        this.$emit("update:optionFilterDate", value);
        this.filterDate.optionFilterDate = value;
        if (value == 2) this.getTodayDate();
      },
    },
  },
  methods: {
    modalOpen() {
      this.$refs.openModal.show();
    },
    modalOk() {
      this.$emit("saveFilter");
    },
    getTodayDate() {
      let fullDate = new Date();

      let dia = fullDate.getDate();
      let mes = fullDate.getMonth() + 1;
      let ano = fullDate.getFullYear();

      if (dia < 10) dia = "0" + dia;
      if (mes < 10) mes = "0" + mes;
      this.todayDate = ano + "-" + mes + "-" + dia;

      this.$emit("update:dateFill", this.todayDate);

      console.log(this.todayDate);
    },
    onChange(value) {
      this.$emit("update:optionFilterDate", value);
      this.filterDate.optionFilterDate = value;
      if (value == 2) this.getTodayDate();
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
.filterDate {
  margin-left: 0px;
  margin-right: 0px;
}
.fieldDate {
  margin-bottom: 10px;
}
.dateIndividual {
  margin-top: 0px;
}
.todayDate {
  text-align: center;
}
</style>
